// TODO: Use a different DSN for different environments (DEV, UAT, PROD)
export const { VITE_SENTRY_DSN: SENTRY_DSN } = import.meta.env
export const { VITE_ENV: ENV } = import.meta.env
